import { ReactElement } from 'react';
import { Button as BaseButton } from 'antd';
import { lang } from 'zf-infra';
import { convert } from '../icons';
import { ButtonProps } from './types';

export function Button(props: ButtonProps): ReactElement {
  const { label, type = 'default', onClick, icon } = props;

  return (
    <BaseButton
      {...props}
      type={type}
      icon={convert(icon)}
      onClick={lang.debounce(event => onClick?.(event), 300)}
    >
      {label}
    </BaseButton>
  );
}
